const Login = () => {
    return(
        <div>
            Hello From Login Page
        </div>
    )
}

export default Login